/**
 * @generated SignedSource<<620d037e94fa0066159ac793111cb22b>>
 * @relayHash 9a452f8b8c8fbb1c6ce0a9372a7161c8
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/567.0.0-2026-07-09T16:56:40.509Z/HpSharedLayoutRefetchQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedLayoutRefetchQuery$variables = {
  abTestList?: ReadonlyArray<string | null> | null;
  fetchInitialHomepage: boolean;
  hasUserId: boolean;
  homepageId: string;
  isClient: boolean;
  isEvergreenCollectionsTestVariant: boolean;
  isHpMixedGridTestVariant: boolean;
  isMobile: boolean;
  isNewArrivalsCarouselTabsTestVariant: boolean;
  isRemoveShopByTestVariant: boolean;
  isRemoveTopHeroBannerTestVariant: boolean;
  isTrade: boolean;
  priceBookName: string;
  userCountryCode: string;
  userId: string;
  userType: string;
};
export type HpSharedLayoutRefetchQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"HpSharedLayout_viewer">;
  };
};
export type HpSharedLayoutRefetchQuery = {
  response: HpSharedLayoutRefetchQuery$data;
  variables: HpSharedLayoutRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": ([]/*:: as any*/),
  "kind": "LocalArgument",
  "name": "abTestList"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchInitialHomepage"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasUserId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "homepageId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isClient"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isEvergreenCollectionsTestVariant"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isHpMixedGridTestVariant"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isMobile"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isNewArrivalsCarouselTabsTestVariant"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isRemoveShopByTestVariant"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isRemoveTopHeroBannerTestVariant"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTrade"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "priceBookName"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userCountryCode"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userType"
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v17 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isHomepageUnionType"
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v19 = [
  {
    "kind": "Variable",
    "name": "userType",
    "variableName": "userType"
  }
],
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageHeight",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageWidth",
  "storageKey": null
},
v23 = {
  "condition": "isMobile",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mobileImageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mobileImageHeight",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mobileImageWidth",
      "storageKey": null
    }
  ]
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "eyeBrowText",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headerText",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dekText",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "backgroundColor",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentColor",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cta",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "LinkData",
  "kind": "LinkedField",
  "name": "linkData",
  "plural": false,
  "selections": [
    (v30/*:: as any*/)
  ],
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMuxVideo",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "videoAutoplay",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cmsDisplayTitle",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cmsId",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "LinkData",
  "kind": "LinkedField",
  "name": "linkData",
  "plural": false,
  "selections": [
    (v30/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLinkable",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ctaLink",
  "storageKey": null
},
v40 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "browseUrl",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryCode",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceTrackingParams",
  "storageKey": null
},
v46 = {
  "alias": "productPhotos",
  "args": [
    {
      "kind": "Literal",
      "name": "limit",
      "value": 1
    }
  ],
  "concreteType": "ItemPhoto",
  "kind": "LinkedField",
  "name": "photos",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "masterOrZoomPath",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "smallPath",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemPhotoVersion",
      "kind": "LinkedField",
      "name": "versions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "webPath",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v42/*:: as any*/)
  ],
  "storageKey": "photos(limit:1)"
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "localizedPdpUrl",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemMeasurement",
  "kind": "LinkedField",
  "name": "measurement",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "addLabel",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "fields",
          "value": [
            "height",
            "width",
            "depth",
            "diameter",
            "length"
          ]
        },
        {
          "kind": "Literal",
          "name": "separator",
          "value": " "
        }
      ],
      "concreteType": "ItemDisplayMeasurementType",
      "kind": "LinkedField",
      "name": "display",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unit",
          "storageKey": null
        },
        (v48/*:: as any*/)
      ],
      "storageKey": "display(addLabel:true,fields:[\"height\",\"width\",\"depth\",\"diameter\",\"length\"],separator:\" \")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSize",
      "kind": "LinkedField",
      "name": "size",
      "plural": false,
      "selections": [
        (v48/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArt",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemClassification",
  "kind": "LinkedField",
  "name": "classification",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "creationDate",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemCreator",
  "kind": "LinkedField",
  "name": "creators",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Creator",
      "kind": "LinkedField",
      "name": "creator",
      "plural": false,
      "selections": [
        (v52/*:: as any*/),
        (v42/*:: as any*/)
      ],
      "storageKey": null
    },
    (v42/*:: as any*/)
  ],
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMultiSku",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isRingItem",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "concreteType": "VariableAttribute",
  "kind": "LinkedField",
  "name": "variableAttributes",
  "plural": true,
  "selections": [
    (v41/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "VariableAttributeSortType",
      "kind": "LinkedField",
      "name": "variableAttributeData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SwatchSort",
          "kind": "LinkedField",
          "name": "swatchSort",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Swatch",
              "kind": "LinkedField",
              "name": "swatch",
              "plural": false,
              "selections": [
                (v41/*:: as any*/),
                (v52/*:: as any*/),
                (v20/*:: as any*/),
                (v42/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v42/*:: as any*/)
  ],
  "storageKey": null
},
v57 = {
  "kind": "Variable",
  "name": "priceBookName",
  "variableName": "priceBookName"
},
v58 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currency",
    "storageKey": null
  }
],
v59 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "isTrade",
      "variableName": "isTrade"
    },
    {
      "kind": "Literal",
      "name": "page",
      "value": "searchAndBrowse"
    },
    (v57/*:: as any*/)
  ],
  "concreteType": "ItemDisplayPriceType",
  "kind": "LinkedField",
  "name": "displayPrice",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ConvertedAmountList",
      "kind": "LinkedField",
      "name": "convertedAmountList",
      "plural": true,
      "selections": (v58/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ConvertedAmountList",
      "kind": "LinkedField",
      "name": "originalConvertedAmountList",
      "plural": true,
      "selections": (v58/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "quantityDisplay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "percentageOff",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "textType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "amountType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showPriceLabel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showPriceVariability",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vertical",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "concreteType": "ShipmentQuote",
  "kind": "LinkedField",
  "name": "shipmentQuotes",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isComplimentary",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCalculated",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "kind": "LinkedField",
      "name": "totalAmount",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ConvertedAmounts",
          "kind": "LinkedField",
          "name": "convertedAmounts",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "USD",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ShipmentServiceMethod",
      "kind": "LinkedField",
      "name": "serviceMethod",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Region",
          "kind": "LinkedField",
          "name": "region",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "regionName",
              "storageKey": null
            },
            (v42/*:: as any*/)
          ],
          "storageKey": null
        },
        (v42/*:: as any*/)
      ],
      "storageKey": null
    },
    (v42/*:: as any*/)
  ],
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "concreteType": "QuickViewDisplayType",
  "kind": "LinkedField",
  "name": "quickViewDisplay",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "QuickViewParagraph",
      "kind": "LinkedField",
      "name": "paragraphs",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        },
        {
          "alias": "mobileText",
          "args": [
            {
              "kind": "Literal",
              "name": "formatType",
              "value": "MOBILE"
            }
          ],
          "kind": "ScalarField",
          "name": "text",
          "storageKey": "text(formatType:\"MOBILE\")"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "QuickViewCreator",
      "kind": "LinkedField",
      "name": "creators",
      "plural": true,
      "selections": [
        (v52/*:: as any*/),
        (v37/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "QuickViewCategorySegments",
      "kind": "LinkedField",
      "name": "paragraphAttributeNames",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "period",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "origin",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "style",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "periodPrefix",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryTitle",
  "storageKey": null
},
v64 = [
  (v41/*:: as any*/),
  (v42/*:: as any*/)
],
v65 = {
  "kind": "Literal",
  "name": "first",
  "value": 6
},
v66 = [
  (v65/*:: as any*/),
  (v57/*:: as any*/),
  {
    "kind": "Literal",
    "name": "uriRef",
    "value": "/collections/editors-picks/"
  },
  {
    "kind": "Variable",
    "name": "userCountryCode",
    "variableName": "userCountryCode"
  }
],
v67 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Item",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v41/*:: as any*/),
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "size",
            "value": "thumb"
          }
        ],
        "kind": "ScalarField",
        "name": "firstPhotoWebPath",
        "storageKey": "firstPhotoWebPath(size:\"thumb\")"
      },
      (v34/*:: as any*/),
      (v45/*:: as any*/),
      (v43/*:: as any*/),
      (v44/*:: as any*/),
      {
        "condition": "hasUserId",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "heartPortfolioItems",
            "args": [
              {
                "kind": "Literal",
                "name": "portfolioType",
                "value": "HEART"
              },
              (v40/*:: as any*/)
            ],
            "concreteType": "PortfolioItemV2",
            "kind": "LinkedField",
            "name": "portfolioItems",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "portfolioId",
                "storageKey": null
              },
              (v42/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "portfolioItemId",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "folderPortfolioItems",
            "args": [
              {
                "kind": "Literal",
                "name": "portfolioType",
                "value": "FOLDER"
              },
              (v40/*:: as any*/)
            ],
            "concreteType": "PortfolioItemV2",
            "kind": "LinkedField",
            "name": "portfolioItems",
            "plural": true,
            "selections": [
              (v16/*:: as any*/),
              (v42/*:: as any*/)
            ],
            "storageKey": null
          }
        ]
      },
      (v46/*:: as any*/),
      (v47/*:: as any*/),
      (v49/*:: as any*/),
      (v50/*:: as any*/),
      (v51/*:: as any*/),
      (v53/*:: as any*/),
      (v37/*:: as any*/),
      (v54/*:: as any*/),
      (v55/*:: as any*/),
      (v56/*:: as any*/),
      (v59/*:: as any*/),
      (v60/*:: as any*/),
      (v61/*:: as any*/),
      (v62/*:: as any*/),
      (v42/*:: as any*/),
      (v16/*:: as any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "cursor",
    "storageKey": null
  }
],
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalResults",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v70 = {
  "condition": "hasUserId",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "userPortfolios",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        },
        {
          "kind": "Literal",
          "name": "portfolioTypes",
          "value": [
            "HEART"
          ]
        },
        {
          "items": [
            {
              "kind": "Variable",
              "name": "userIds.0",
              "variableName": "userId"
            }
          ],
          "kind": "ListValue",
          "name": "userIds"
        }
      ],
      "concreteType": "PortfoliosConnection",
      "kind": "LinkedField",
      "name": "portfolios",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PortfoliosEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PortfolioV2",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v64/*:: as any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
},
v71 = {
  "alias": "favoritesPageRedesignFF",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "favoritesPageRedesign"
    }
  ],
  "kind": "ScalarField",
  "name": "featureFlag",
  "storageKey": "featureFlag(feature:\"favoritesPageRedesign\")"
},
v72 = [
  (v65/*:: as any*/),
  {
    "kind": "Literal",
    "name": "module",
    "value": "MOST_SAVED_MODULE"
  }
],
v73 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ItemSearchTreandingEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": (v67/*:: as any*/),
    "storageKey": null
  },
  (v68/*:: as any*/),
  (v69/*:: as any*/)
],
v74 = [
  (v65/*:: as any*/),
  {
    "kind": "Literal",
    "name": "module",
    "value": "EXCELLENT_VALUES_MODULE"
  }
],
v75 = [
  (v65/*:: as any*/),
  {
    "kind": "Literal",
    "name": "module",
    "value": "BEST_SELLING_MODULE"
  }
],
v76 = [
  {
    "condition": "isClient",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "alias": "mostSavedItems",
        "args": (v72/*:: as any*/),
        "concreteType": "ItemSearchTreandingConnection",
        "kind": "LinkedField",
        "name": "itemSearchTrending",
        "plural": false,
        "selections": (v73/*:: as any*/),
        "storageKey": "itemSearchTrending(first:6,module:\"MOST_SAVED_MODULE\")"
      },
      {
        "alias": "mostSavedItems",
        "args": (v72/*:: as any*/),
        "filters": ([]/*:: as any*/),
        "handle": "connection",
        "key": "HpSharedMostSavedItemsCarousel_mostSavedItems",
        "kind": "LinkedHandle",
        "name": "itemSearchTrending"
      },
      {
        "alias": "excellentValuesItems",
        "args": (v74/*:: as any*/),
        "concreteType": "ItemSearchTreandingConnection",
        "kind": "LinkedField",
        "name": "itemSearchTrending",
        "plural": false,
        "selections": (v73/*:: as any*/),
        "storageKey": "itemSearchTrending(first:6,module:\"EXCELLENT_VALUES_MODULE\")"
      },
      {
        "alias": "excellentValuesItems",
        "args": (v74/*:: as any*/),
        "filters": ([]/*:: as any*/),
        "handle": "connection",
        "key": "HpSharedExcellentValuesCarousel_excellentValuesItems",
        "kind": "LinkedHandle",
        "name": "itemSearchTrending"
      },
      {
        "alias": "bestsellingDesigns",
        "args": (v75/*:: as any*/),
        "concreteType": "ItemSearchTreandingConnection",
        "kind": "LinkedField",
        "name": "itemSearchTrending",
        "plural": false,
        "selections": (v73/*:: as any*/),
        "storageKey": "itemSearchTrending(first:6,module:\"BEST_SELLING_MODULE\")"
      },
      {
        "alias": "bestsellingDesigns",
        "args": (v75/*:: as any*/),
        "filters": ([]/*:: as any*/),
        "handle": "connection",
        "key": "HpSharedBestsellingDesignsCarousel_bestsellingDesigns",
        "kind": "LinkedHandle",
        "name": "itemSearchTrending"
      }
    ]
  }
],
v77 = {
  "alias": "muxMonitoringFF",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "muxMonitoring"
    }
  ],
  "kind": "ScalarField",
  "name": "featureFlag",
  "storageKey": "featureFlag(feature:\"muxMonitoring\")"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/),
      (v6/*:: as any*/),
      (v7/*:: as any*/),
      (v8/*:: as any*/),
      (v9/*:: as any*/),
      (v10/*:: as any*/),
      (v11/*:: as any*/),
      (v12/*:: as any*/),
      (v13/*:: as any*/),
      (v14/*:: as any*/),
      (v15/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "HpSharedLayoutRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "HpSharedLayout_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*:: as any*/),
      (v14/*:: as any*/),
      (v3/*:: as any*/),
      (v7/*:: as any*/),
      (v1/*:: as any*/),
      (v15/*:: as any*/),
      (v0/*:: as any*/),
      (v13/*:: as any*/),
      (v11/*:: as any*/),
      (v12/*:: as any*/),
      (v4/*:: as any*/),
      (v9/*:: as any*/),
      (v5/*:: as any*/),
      (v10/*:: as any*/),
      (v8/*:: as any*/),
      (v6/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "HpSharedLayoutRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "abTestList",
                "variableName": "abTestList"
              },
              {
                "kind": "Variable",
                "name": "rootId",
                "variableName": "homepageId"
              }
            ],
            "concreteType": "Homepage",
            "kind": "LinkedField",
            "name": "homepage",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "modules",
                "plural": true,
                "selections": [
                  (v16/*:: as any*/),
                  {
                    "condition": "isRemoveTopHeroBannerTestVariant",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      (v17/*:: as any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v18/*:: as any*/),
                          {
                            "alias": null,
                            "args": (v19/*:: as any*/),
                            "concreteType": "TopHeroBannerMessages",
                            "kind": "LinkedField",
                            "name": "messages",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TopHeroBannerItem",
                                "kind": "LinkedField",
                                "name": "items",
                                "plural": true,
                                "selections": [
                                  {
                                    "condition": "isMobile",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                      (v20/*:: as any*/),
                                      (v21/*:: as any*/),
                                      (v22/*:: as any*/)
                                    ]
                                  },
                                  (v23/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "HeroBannerSettingsType",
                                    "kind": "LinkedField",
                                    "name": "heroBannerSettings",
                                    "plural": false,
                                    "selections": [
                                      (v24/*:: as any*/),
                                      (v25/*:: as any*/),
                                      (v26/*:: as any*/),
                                      (v27/*:: as any*/),
                                      (v28/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v29/*:: as any*/),
                                  (v31/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "videoUrl",
                                    "storageKey": null
                                  },
                                  (v32/*:: as any*/),
                                  (v33/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "mediaFormat",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "TopHeroBannerModule",
                        "abstractKey": null
                      }
                    ]
                  },
                  {
                    "condition": "fetchInitialHomepage",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v18/*:: as any*/),
                          (v34/*:: as any*/),
                          (v35/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Product",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                              (v36/*:: as any*/),
                              (v34/*:: as any*/),
                              (v20/*:: as any*/),
                              (v37/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "CollectionsModule",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v18/*:: as any*/),
                          (v34/*:: as any*/),
                          {
                            "alias": null,
                            "args": (v19/*:: as any*/),
                            "concreteType": "EditorialItem",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                              (v20/*:: as any*/),
                              (v34/*:: as any*/),
                              (v29/*:: as any*/),
                              (v31/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "EditorialModule",
                        "abstractKey": null
                      }
                    ]
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "index",
                        "storageKey": null
                      },
                      (v18/*:: as any*/),
                      {
                        "alias": null,
                        "args": (v19/*:: as any*/),
                        "concreteType": "PromoModuleMessages",
                        "kind": "LinkedField",
                        "name": "messages",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PromoItem",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                              (v16/*:: as any*/),
                              (v36/*:: as any*/),
                              {
                                "condition": "isMobile",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                  (v22/*:: as any*/),
                                  (v20/*:: as any*/),
                                  (v21/*:: as any*/)
                                ]
                              },
                              (v37/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "imageCopy",
                                "storageKey": null
                              },
                              (v29/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isFullBleedImage",
                                "storageKey": null
                              },
                              (v34/*:: as any*/),
                              (v38/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "format",
                                "storageKey": null
                              },
                              (v23/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "HeroBannerSettingsType",
                                "kind": "LinkedField",
                                "name": "heroBannerSettings",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "textAlignment",
                                    "storageKey": null
                                  },
                                  (v28/*:: as any*/),
                                  (v24/*:: as any*/),
                                  (v25/*:: as any*/),
                                  (v26/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "ctaStyle",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "contentPosition",
                                    "storageKey": null
                                  },
                                  (v27/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "bannerImageWidth",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v34/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ctaUrl",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ctaCopy",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v35/*:: as any*/)
                    ],
                    "type": "PromoModule",
                    "abstractKey": null
                  },
                  {
                    "condition": "isRemoveShopByTestVariant",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      (v17/*:: as any*/),
                      {
                        "condition": "isClient",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v18/*:: as any*/),
                              (v34/*:: as any*/),
                              (v35/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Product",
                                "kind": "LinkedField",
                                "name": "items",
                                "plural": true,
                                "selections": [
                                  (v37/*:: as any*/),
                                  (v34/*:: as any*/),
                                  (v38/*:: as any*/),
                                  (v29/*:: as any*/),
                                  (v20/*:: as any*/),
                                  (v21/*:: as any*/),
                                  (v22/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ShopByModule",
                            "abstractKey": null
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v18/*:: as any*/)
                    ],
                    "type": "LocationsModule",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v18/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "visible",
                        "storageKey": null
                      },
                      (v34/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "subText",
                        "storageKey": null
                      },
                      (v29/*:: as any*/),
                      (v39/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "image",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "mobileImage",
                        "storageKey": null
                      }
                    ],
                    "type": "BottomBannerModule",
                    "abstractKey": null
                  },
                  {
                    "condition": "isClient",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v18/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "userType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "videoId",
                            "storageKey": null
                          },
                          (v39/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "eyebrow",
                            "storageKey": null
                          },
                          (v34/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ctaText",
                            "storageKey": null
                          },
                          (v33/*:: as any*/),
                          (v32/*:: as any*/)
                        ],
                        "type": "VideoModule",
                        "abstractKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "condition": "hasUserId",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 3
                      },
                      {
                        "kind": "Literal",
                        "name": "numItems",
                        "value": 3
                      },
                      (v40/*:: as any*/)
                    ],
                    "concreteType": "PersonalizationModuleConnection",
                    "kind": "LinkedField",
                    "name": "personalization",
                    "plural": false,
                    "selections": [
                      {
                        "condition": "isNewArrivalsCarouselTabsTestVariant",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PersonalizationModuleEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PersonalizationModule",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Item",
                                    "kind": "LinkedField",
                                    "name": "categoryItems",
                                    "plural": true,
                                    "selections": [
                                      (v41/*:: as any*/),
                                      (v42/*:: as any*/),
                                      (v43/*:: as any*/),
                                      (v44/*:: as any*/),
                                      (v45/*:: as any*/),
                                      (v46/*:: as any*/),
                                      (v47/*:: as any*/),
                                      (v49/*:: as any*/),
                                      (v50/*:: as any*/),
                                      (v34/*:: as any*/),
                                      (v51/*:: as any*/),
                                      (v53/*:: as any*/),
                                      (v37/*:: as any*/),
                                      (v54/*:: as any*/),
                                      (v55/*:: as any*/),
                                      (v56/*:: as any*/),
                                      (v59/*:: as any*/),
                                      (v60/*:: as any*/),
                                      (v61/*:: as any*/),
                                      (v62/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v31/*:: as any*/),
                                  (v63/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "numItems",
                        "value": 10
                      },
                      {
                        "kind": "Literal",
                        "name": "pageSize",
                        "value": 3
                      },
                      (v40/*:: as any*/)
                    ],
                    "concreteType": "PersonalizationCollectionType",
                    "kind": "LinkedField",
                    "name": "personalizationCollections",
                    "plural": true,
                    "selections": [
                      {
                        "condition": "isNewArrivalsCarouselTabsTestVariant",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v63/*:: as any*/),
                          (v31/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Item",
                            "kind": "LinkedField",
                            "name": "categoryItems",
                            "plural": true,
                            "selections": (v64/*:: as any*/),
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "storageKey": null
                  }
                ]
              }
            ],
            "storageKey": null
          },
          (v42/*:: as any*/),
          {
            "condition": "isHpMixedGridTestVariant",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "condition": "isClient",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": "editorsPicks",
                    "args": (v66/*:: as any*/),
                    "concreteType": "ItemSearchItemsConnection",
                    "kind": "LinkedField",
                    "name": "itemSearchItems",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemSearchItemsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": (v67/*:: as any*/),
                        "storageKey": null
                      },
                      (v68/*:: as any*/),
                      (v69/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "editorsPicks",
                    "args": (v66/*:: as any*/),
                    "filters": [],
                    "handle": "connection",
                    "key": "HpSharedHeroCarousel_editorsPicks",
                    "kind": "LinkedHandle",
                    "name": "itemSearchItems"
                  },
                  (v70/*:: as any*/),
                  (v71/*:: as any*/)
                ]
              },
              {
                "condition": "isEvergreenCollectionsTestVariant",
                "kind": "Condition",
                "passingValue": true,
                "selections": (v76/*:: as any*/)
              },
              {
                "condition": "isEvergreenCollectionsTestVariant",
                "kind": "Condition",
                "passingValue": false,
                "selections": (v76/*:: as any*/)
              }
            ]
          },
          {
            "condition": "isNewArrivalsCarouselTabsTestVariant",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              (v16/*:: as any*/),
              (v71/*:: as any*/)
            ]
          },
          {
            "condition": "isNewArrivalsCarouselTabsTestVariant",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v70/*:: as any*/),
              (v71/*:: as any*/)
            ]
          },
          {
            "condition": "isClient",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OnSaleVertical",
                "kind": "LinkedField",
                "name": "onSaleVerticals",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "category",
                    "storageKey": null
                  },
                  (v52/*:: as any*/),
                  (v31/*:: as any*/)
                ],
                "storageKey": null
              },
              (v77/*:: as any*/)
            ]
          },
          {
            "condition": "isRemoveTopHeroBannerTestVariant",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              (v77/*:: as any*/)
            ]
          },
          {
            "condition": "hasUserId",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v40/*:: as any*/)
                ],
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": "hasLoggedInWithApp",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "deviceType",
                        "value": "IOS_APP"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasLoggedInWithDeviceType",
                    "storageKey": "hasLoggedInWithDeviceType(deviceType:\"IOS_APP\")"
                  },
                  (v41/*:: as any*/),
                  {
                    "alias": "canShowStorefrontOnlyBadge",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "VIEW_STOREFRONT_ONLY_BADGE"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasPermission",
                    "storageKey": "hasPermission(name:\"VIEW_STOREFRONT_ONLY_BADGE\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canShowFolder",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Profile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "firstName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "testType",
                        "value": "BUYER_USER"
                      }
                    ],
                    "concreteType": "AbTestConfigV2UserVariant",
                    "kind": "LinkedField",
                    "name": "abTestV2List",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AbTestConfigV2",
                        "kind": "LinkedField",
                        "name": "config",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "createdDate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "modifiedDate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "testName",
                            "storageKey": null
                          },
                          (v38/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "testType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "audience",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ramp",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isActive",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "route",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ABTestConfigV2Variation",
                            "kind": "LinkedField",
                            "name": "variations",
                            "plural": true,
                            "selections": [
                              (v48/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "weight",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v42/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "variant",
                        "storageKey": null
                      }
                    ],
                    "storageKey": "abTestV2List(testType:\"BUYER_USER\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserRecommendations",
                    "kind": "LinkedField",
                    "name": "twoTowerModelItemRecommendations",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "recommendationIds",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v42/*:: as any*/)
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-misc/567.0.0-2026-07-09T16:56:40.509Z/HpSharedLayoutRefetchQuery",
    "metadata": {},
    "name": "HpSharedLayoutRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "63a1fffbffeb0a2f38e43a4c33a2311e";

export default node;
